import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register PWA / push service worker once the page is loaded
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => console.warn('SW registration failed:', err));

    // When a redeploy ships a new SW, the activate handler in sw.js posts
    // HCA_SW_UPDATED to every open tab. We catch it here and soft-reload so
    // the browser picks up the freshly-deployed bundle automatically, with
    // no "clear your cache" instructions needed. Guarded against reload loops
    // by a sessionStorage tombstone valid for 60 s.
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data || {};
      if (data.type !== 'HCA_SW_UPDATED') return;
      try {
        const last = parseInt(sessionStorage.getItem('hca.sw_reloaded_at') || '0', 10);
        if (Date.now() - last < 60_000) return; // recently reloaded — skip
        sessionStorage.setItem('hca.sw_reloaded_at', String(Date.now()));
      } catch (e) { /* private mode etc. */ }
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
